module.exports = __webpack_public_path__ + "static/media/icon.d3c4a09a.svg";